import moment from "vue-moment";
import Vue from "vue";

Vue.use(moment);
